import styled from 'styled-components';
import { Button } from 'antd';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';

const SecondaryButton = styled(Button)`
    white-space: initial;
    height: auto;
    background-color: transparent;
    color: ${props => props.theme.text.black} !important;
    border-color: ${props => props.theme.background.theme || COLORS.BUTTON_BACKGROUND};
    border-width: ${STYLES.BORDER_WIDTH};
    border-radius: ${STYLES.BUTTON_BORDER_RADIUS};
    text-transform: uppercase;
    padding: ${STYLES.BUTTON_PADDING};
    font-weight: ${FONTS.SEMI_BOLD};
    font-size: ${FONTS.DESCRIPTION_FONT_SIZE};
    line-height: ${FONTS.DESCRIPTION_FONT_SIZE};
    display: flex;
    flex-direction: row-reverse;
    gap: 8px;

    &:hover {
        > span {
            color: ${props => props.theme.text.black} !important;
        }
        color: ${props => props.theme.text.black} !important;
        background-color: ${props => props.theme.background.theme || COLORS.BUTTON_BACKGROUND};
        border-color: ${props => props.theme.background.theme || COLORS.BUTTON_BACKGROUND};
    }
`;

export default SecondaryButton;
